import { without } from '@/globals';

import * as types from './mutation-types';

const mutations = {
  [types.CREATE_USERSETTING](state, userSetting) {
    state.userSetting = userSetting;
  },

  [types.UPDATE_USERSETTINGS_LIST](state, userSettings) {
    state.userSettings = userSettings;
  },

  [types.UPDATE_USERSETTING](state, userSetting) {
    if (state.userSettings.find((c) => c.key === userSetting.key) === undefined) {
      state.userSettings = [...state.userSettings, userSetting];
    } else {
      state.userSettings = [
        ...without(
          state.userSettings,
          state.userSettings.find((c) => c.key === userSetting.key),
        ),
        userSetting,
      ];
    }
  },

  /**
   * @param {{id: string}} userSetting
   */
  [types.DELETE_USERSETTING](state, userSetting) {
    state.userSettings = state.userSettings?.filter((setting) => userSetting.id !== setting.key);
  },
};

export default mutations;
